import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import {Card, Col, Row, Tabs} from "antd";
import {useEffect, useState} from "react";
import ApiService from "../Service/ApiService";
import {DataGridProvider} from "../Components/data-grid/DataGridContext";
import CheckHistory from "../Components/CheckHistory";
import CompareHistory from "../Components/CompareHistory";
import DashboardItem from "../Components/DashboardItem";
import UserDashboardData from "../Components/UserDashboardData";

export default function UserDashboard() {
    const [statistics, setStatistics] = useState({})

    const getStatistics = async () => {
        const res = await ApiService.UserProject.UserStatistics()
        if(res.success) {
            setStatistics(res.data)
        }
    }

    useEffect(() => {
        getStatistics()
    }, [])

    return (
        <>
            <BaseLayout>
                <UserDashboardData
                    projectCount={statistics.projectCount}
                    planCount={statistics.planCount}
                    checkCount={statistics.checkCount}
                    compareCount={statistics.compareCount}
                    checkMessageCount={statistics.checkMessageCount}
                    compareMessageCount={statistics.compareMessageCount}
                />
                <br/>
                <Card title={'History'}>
                    <Tabs>
                        <Tabs.TabPane tab={'Check History'} key={'Check History'}>
                            <DataGridProvider>
                                <CheckHistory />
                            </DataGridProvider>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'Compare History'} key={'Compare History'}>
                            <DataGridProvider>
                                <CompareHistory />
                            </DataGridProvider>
                        </Tabs.TabPane>
                    </Tabs>
                </Card>
            </BaseLayout>
        </>
    )
}